module.exports = __webpack_public_path__ + "img/bg-flow.9a38addf.png";